export const REVIEWS_PAGINATED_SIZE = 3;
